import { useState, useEffect } from "react";
import "./CirculatCountDownTimer.css";

const CircularCountDownTimer = ({ seconds, text }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (!isActive || timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          setIsActive(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, timeLeft]);

  // Calculate the progress percentage for the animation
  const progress = (timeLeft / seconds) * 100;
  const strokeDashoffset = 440 - (440 * progress) / 100;

  // Reset the countdown
  const resetCountdown = () => {
    setTimeLeft(seconds);
    setIsActive(true);
  };

  return (
    <div className="circular-countdown-container">
      <div className="circular-countdown-text">{text}</div>
      <div className="circular-countdown-wrapper">
        <svg className="circular-countdown-svg" viewBox="0 0 160 160">
          <circle
            className="circular-countdown-circle-bg"
            cx="80"
            cy="80"
            r="70"
          />
          <circle
            className="circular-countdown-circle"
            cx="80"
            cy="80"
            r="70"
            style={{ strokeDashoffset }}
          />
        </svg>
        <div className="circular-countdown-number">
          <span>{timeLeft}</span>
        </div>
      </div>
    </div>
  );
};

export default CircularCountDownTimer;
